// @ts-nocheck
import React, { ReactNode } from 'react';
import styled from 'styled-components';
const Title = styled.div.withConfig({
  displayName: "DashboardCard__Title",
  componentId: "sc-1dug4e1-0"
})(["display:flex;justify-content:", ";font-size:1.2em;font-weight:900;color:#adb8c3;"], props => props.textPosition);
const Card = styled.div.withConfig({
  displayName: "DashboardCard__Card",
  componentId: "sc-1dug4e1-1"
})(["display:flex;flex-direction:", ";align-items:stretch;background:white;border-radius:0.25em;height:100%;padding:1em;box-sizing:border-box;"], props => props.directionReverse ? 'column-reverse' : 'column');
export default ({
  titlePosition = 'top',
  textPosition = 'center',
  ...props
}) => {
  return <Card directionReverse={titlePosition === 'bottom'}>
      <Title directionReverse={titlePosition === 'bottom'} textPosition={textPosition}>
        {props.title}
      </Title>
      {props.children}
    </Card>;
};
